import * as parse from './utils/parse';
import * as config from './utils/config';
import * as format from './utils/format';
import * as api from './utils/api';
import constants from './utils/constants';
import { init } from './utils/dependency';
import { helpers } from './stores';
import validation from './utils/validation';
import Pagination from './utils/pagination';

const extensions = {
  Pagination,
  validation,
  ...config,
  ...parse,
  ...format,
  ...api,
  ...helpers,
  const: constants
};

export default {
  install (Vue, { i18n, processDatePickerShortcut }) {
    // store reference to our dependencies
    init({ i18n });

    // install all formatting functions as Vue filters
    Vue.mixin({
      filters: {
        ...format
      }
    });

    // register the Cove components
    let requireComponent = require.context('./components', false, /.*\.vue$/);
    requireComponent.keys().forEach((fileName) => {
      const componentConfig = requireComponent(fileName);
      const componentName = fileName.replace(/^\.\//, '').replace(/\.vue$/, '');
      Vue.component(componentName, componentConfig.default || componentConfig);
    });

    if (processDatePickerShortcut)
    {
      extensions.processDatePickerShortcut = processDatePickerShortcut;
    }

    // expose all Cove functionality on $cove
    Vue.prototype.$cove = extensions;
  },

  // expose all Cove functionality on the Cove object/export itself
  ...extensions
};
